export const taxPercent = 9 + 12;
